import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  margin: 0 0 1.25rem 0;
  padding: 1rem 1rem;
  background-color: ${props => props.theme.colors.backgroundContent};
`
